import type { FC } from 'react';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import SnapChatIcon from '@/shared/icons/SnapChatIcon';
import { AvailablePlatformsEnum } from '@/editor/shared/constants/available-platforms';

interface IPlatformIconProps {
  platform: string;
}

const PlatformIcon: FC<IPlatformIconProps> = ({ platform }) => {
  const iconStyle = { fontSize: '32px' };
  const imageStyle = { fontSize: 'large', width: '32px', height: '32px' };

  switch (platform) {
    case AvailablePlatformsEnum.META:
      return <FacebookIcon sx={iconStyle} />;

    case AvailablePlatformsEnum.GOOGLE_ADS:
      return <GoogleIcon sx={iconStyle} />;

    case AvailablePlatformsEnum.SNAPCHAT:
      return <SnapChatIcon fontSize={'large'} />;

    case AvailablePlatformsEnum.DELTA:
      return <NewspaperIcon sx={iconStyle} />;

    case AvailablePlatformsEnum.BIDTHEATRE:
      return <img src="/images/bidtheatre/bidtheatre.png" alt="Bidtheatre" style={imageStyle} />;

    case AvailablePlatformsEnum.BOARDS:
      return <img src="/images/boards/boards_logo.jpg" alt="Boards" style={imageStyle} />;

    default:
      return null;
  }
};

export default PlatformIcon;
